module.exports = __webpack_public_path__ + "img/confirm-avatar.043d371f.svg";